var React = require('react');

function BallotInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ballot.inline"),React.createElement("g",{"id":"eab0c9f2-e4e3-4f0d-a9a4-65a60e5e418b","data-name":"Layer 2","key":1},React.createElement("g",{"id":"f3b92d0c-898c-4729-95e9-ae4a7d685410","data-name":"Layer 1"},React.createElement("path",{"id":"bbf95683-1147-4db6-a42f-ec26c60904e6","data-name":"ballot.inline","d":"M24.3,11.66H14.45V.81H24.3Zm-11.44,0H26M24.3,6H30l8.1,11.34H.81L8.91,6h5.53M38.07,35.15H.81V17.34H38.07Z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.62"})))]);
}

BallotInline.defaultProps = {"viewBox":"0 0 38.88 35.96","id":"ballot-svg"};

module.exports = BallotInline;

BallotInline.default = BallotInline;
